import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";

export interface GoogleEventDto {
    id: string;
    summary: string;
    start?: string;
    end?: string;
    iCalUID?: string;
}

export default function useGoogleCalendar() {
    const showToast = useToast();
    const { setLoading } = useContext(LoadingContext);

    const [googleEvents, setGoogleEvents] = useState<GoogleEventDto[]>([]);

    async function getGoogleStartUrl(returnUrl?: string) {
        try {
            const res = await api.get("/google/oauth/start-url", {
                params: { returnUrl: returnUrl ?? window.location.href },
            });
            return String(res.data?.url || "");
        } catch (err) {
            console.error("Erro getGoogleStartUrl:", err);
            showToast("error", "Não foi possível iniciar o login do Google.");
            return "";
        }
    }

    async function connectGoogle(returnUrl?: string) {
        setLoading(true);
        try {
            const url = await getGoogleStartUrl(returnUrl);
            if (url) window.location.assign(url);
        } finally {
            setLoading(false);
        }
    }

    async function getGoogleEvents(startUtc: string, endUtc: string) {
        setLoading(true);
        try {
            const res = await api.get<GoogleEventDto[]>("/google/calendar/events", {
                params: { startUtc, endUtc },
            });
            const arr = Array.isArray(res.data) ? res.data : [];
            setGoogleEvents(arr);
            return arr;
        } catch (err) {
            console.error("Erro getGoogleEvents:", err);
            showToast("error", "Erro ao buscar eventos do Google.");
            return null;
        } finally {
            setLoading(false);
        }
    }

    return {
        googleEvents,
        getGoogleStartUrl,
        connectGoogle,
        getGoogleEvents,
        setGoogleEvents,
    };
}